import { encodeCustomAttributeKeyForForm } from 'lib/customAttributes';

const getUsersMergeInitialValues = ({ access, courses, user }) => {
  const initialValues = {};

  // new courses
  if (access.courses.new.length) {
    access.courses.new.forEach((course) => {
      initialValues[`accessCourse-${course.id}`] = true;
    });
  }

  // new groups
  if (access.groups.new.length) {
    access.groups.new.forEach((group) => {
      initialValues[`accessGroup-${group.id}`] = true;
    });
  }

  // new learning paths
  if (access.paths.new.length) {
    access.paths.new.forEach((path) => {
      initialValues[`accessPath-${path.id}`] = true;
    });
  }

  // conflicts on user details
  let conflicts = Object.keys(user['customAttributes-conflicts']);
  if (conflicts) {
    conflicts.forEach((attr) => {
      initialValues[
        `customAttribute-${encodeCustomAttributeKeyForForm(attr)}`
      ] = user['customAttributes-conflicts'][attr][0].value;
    });
  }

  // conflicts on course data
  conflicts = courses.conflicts;
  if (conflicts) {
    conflicts.forEach((conflict) => {
      const label = `courseConflict-${conflict.target.id}`;

      if (conflict.action === 'merge') initialValues[label] = 'merge';
      else {
        if (
          (conflict.target.completion.status !== 'success' &&
            conflict.source.completion.status === 'success') ||
          (conflict.source.completion.status === 'success' &&
            conflict.source.completionDate > conflict.target.completionDate)
        )
          initialValues[label] = 'keepSource';
        else initialValues[label] = 'keepTarget';
      }
    });
  }

  return initialValues;
};

export default getUsersMergeInitialValues;
